import * as tools from '@/components/tools';
import * as regulars from '@/components/regulars';
  
export default {
    tools,
    regulars
}